<template>
  <div
    v-if="pass"
    class="v3kiosk-active-pass"
    data-testid="kiosk-ended-pass-status"
  >
    <CRow class="justify-content-center">
      <hr class="kiosk-horizontal-line mb-2" />
      <div class="v3kiosk-active-pass-title mb-2">
        <div>{{ $t("kiosk.end_pass_title") }}</div>
      </div>

      <StatusBox
        class="d-flex justify-content-center mb-2"
        :title="$t('kiosk.pass_ended')"
        title-color="#ffffff"
        background-color="#008566"
        icon="ri-checkbox-circle-line"
        icon-color="#ffffff"
      />

      <CCol class="v3kiosk-active-pass-table mb-2">
        <CRow class="v3kiosk-active-pass-table-header mb-1">
          <CCol class="v3kiosk-active-pass-table-header-info text-start ms-1">
            <div class="created-at">
              {{
                $helpers.transformDate(pass.created_at, "dddd, DD, MMMM, YYYY")
              }}
            </div>
            <div class="time">
              {{ $t("kiosk.time") }}
              {{ $helpers.transformDate(pass.created_at, "h:mm a") }}
            </div>
          </CCol>
        </CRow>
        <CRow class="v3kiosk-active-pass-table-content">
          <CCol class="v3kiosk-active-pass-table-content-text">
            {{ pass.from?.name || "" }}
          </CCol>
          <CCol class="v3kiosk-active-pass-table-content-icon">
            <i class="ri-arrow-go-back-line" />
          </CCol>
          <CCol class="v3kiosk-active-pass-table-content-text">
            {{ pass.to?.name || "" }}
          </CCol>
        </CRow>
        <CRow class="v3kiosk-active-pass-table-bottom mt-1">
          <CCol
            class="v3kiosk-active-pass-table-bottom-type d-flex flex-column justify-content-center align-content-center ms-1"
          >
            <div class="v3kiosk-active-pass-table-bottom-type-box">
              <div class="icon align-self-center">
                <i class="ri-device-line" />
              </div>
              <div class="text">{{ $t("kiosk.ksk") }}</div>
            </div>
          </CCol>
        </CRow>
      </CCol>

      <div class="d-flex justify-content-center mt-2">
        <BaseButton
          class="w-50 d-flex align-items-center justify-content-center"
          rounded
          data-testid="kiosk-ended-pass-close"
          :aria-label="closeButtonLabel"
          @click="close()"
        >
          {{ $t("kiosk.close") }}({{ timeoutCounter }})
        </BaseButton>
      </div>

      <div class="d-flex align-items-center justify-content-center mt-5">
        <a
          class="kiosk-terms-and-privacy-text"
          target="_blank"
          href="https://www.securly.com/terms-and-conditions"
          >{{ $t("kiosk.terms_of_use") }}</a
        >
        <span class="mx-2">|</span>
        <a
          class="kiosk-terms-and-privacy-text"
          target="_blank"
          href="https://www.securly.com/privacy"
          >{{ $t("kiosk.privacy_policy") }}</a
        >
      </div>
    </CRow>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, reactive } from "vue"
import { useI18n } from "vue-i18n"
import moment from "moment"
import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"
import StatusBox from "@/v3components/shared/Alerts/StatusBox.vue"

export default {
  name: "KioskEndedPassStatus",

  components: { BaseButton, StatusBox },

  props: {
    pass: {
      type: Object,
      default: null
    }
  },

  emits: ["close"],

  setup(props, { emit }) {
    const { t } = useI18n()

    const state = reactive({
      timeout: 120,
      interval: null
    })

    const timeoutCounter = computed(() => {
      return moment.utc(state.timeout * 1000).format("mm:ss")
    })

    const closeButtonLabel = computed(() => {
      return `${t("kiosk.close")}(${timeoutCounter.value})`
    })

    const close = () => {
      if (state.interval) {
        clearInterval(state.interval)
        state.interval = null
      }
      emit("close")
    }

    const initTimeout = () => {
      if (state.interval) return

      state.interval = setInterval(() => {
        if (state.timeout > 0) {
          state.timeout--
        }
        if (state.timeout <= 0) {
          clearInterval(state.interval)
          state.interval = null
          close()
        }
      }, 1000)
    }

    onMounted(() => {
      initTimeout()
    })

    onUnmounted(() => {
      if (state.interval) {
        clearInterval(state.interval)
        state.interval = null
      }
    })

    return {
      timeoutCounter,
      closeButtonLabel,
      close
    }
  }
}
</script>
